import classNames from 'classnames';

import { Programme } from '@components/programme/Programme';

import {
	EventCollectionRecord,
	PaginationData,
	ProgrammeLabels,
} from '@interfaces';

import styles from './event-collection.module.scss';

interface EventCollectionProps extends EventCollectionRecord {
	className?: string;
	programmeLabels?: ProgrammeLabels;
	paginationData?: PaginationData;
	isEventsDataLoading?: boolean;
}

export const EventCollection = ({
	className,
	title,
	showTitle,
	description,
	events,
	view,
	programmeLabels,
	showTicketAnchors,
	accessCodeValue,
	paginationData,
	isEventsDataLoading,
}: EventCollectionProps) => {
	return (
		<div className={classNames(className, styles['event-collection'])}>
			<header className={styles['event-collection__header']}>
				{showTitle && (
					<h2 className={styles['event-collection__heading']}>{title}</h2>
				)}
				{!!description && (
					<p className={styles['event-collection__description']}>
						{description}
					</p>
				)}
			</header>
			{events?.length ? (
				<Programme
					accessCodeValue={accessCodeValue}
					className={styles['event-collection__programme']}
					events={events}
					isLoading={isEventsDataLoading}
					paginationData={paginationData}
					previewHeadingTag="h3"
					programmeLabels={programmeLabels}
					showTicketAnchors={showTicketAnchors}
					view={view}
				/>
			) : null}
		</div>
	);
};
